import { Text, View } from '@react-pdf/renderer';
import React from 'react';
import { styles } from '../../../utils/styles';
import defaults from '../../../translations/en.json';
import { AT_RISK, PAYER_NAME, POLICY_NUMBER } from '../constants';

const parseFunding = fundingSource => {
  if (!Array.isArray(fundingSource)) {
    return `${fundingSource[PAYER_NAME]} ${fundingSource[POLICY_NUMBER]}`;
  }

  const primarySource = fundingSource.find(source => source.type === 'primary');
  const secondarySource = fundingSource.find(source => source.type === 'secondary');
  return `${primarySource[PAYER_NAME]} ${primarySource[POLICY_NUMBER]} / ${secondarySource[PAYER_NAME]} ${secondarySource[POLICY_NUMBER]}`;
};

export const PatientInformation = ({
  patient,
  fundingSource
}) => {
  const fundingInfo = fundingSource && parseFunding(fundingSource);
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.width100, styles.borderBottomBlack]
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.printerHeaderText
  }, `${defaults.patientInformation}`), /*#__PURE__*/React.createElement(View, {
    style: styles.row
  }, /*#__PURE__*/React.createElement(View, {
    style: [styles.width66, styles.textAlignCenter]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.row
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.FacesheetHeaderField
  }, `${defaults.primarySecondaryFundingSource}: `), /*#__PURE__*/React.createElement(Text, {
    style: styles.FacesheetText
  }, fundingInfo))), /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.row
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.FacesheetHeaderField
  }, `${defaults.ssn}: `), /*#__PURE__*/React.createElement(Text, {
    style: styles.FacesheetText
  }, `${patient.ss}`))), /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.row
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.FacesheetHeaderField
  }, `${defaults.primaryLanguage}: `), /*#__PURE__*/React.createElement(Text, {
    style: styles.FacesheetText
  }, `${patient.language}`)))), /*#__PURE__*/React.createElement(View, {
    style: [styles.width33, styles.textAlignCenter]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetHeaderField, styles.pYPointOneCm]
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.row
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.FacesheetHeaderField
  }, `${defaults.religionChurch}: `), /*#__PURE__*/React.createElement(Text, {
    style: styles.FacesheetText
  }, patient.religion, " / ", patient.church))), /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.row
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.FacesheetHeaderField
  }, `${defaults.atRisk}: `), /*#__PURE__*/React.createElement(Text, {
    style: styles.FacesheetText
  }, patient[AT_RISK]))), /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.row
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.FacesheetHeaderField
  }, `${defaults.veteran}: `), /*#__PURE__*/React.createElement(Text, {
    style: styles.FacesheetText
  }, `${patient.veteran}`))))));
};